import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import CoreStyles from '../core/Styles';
import {LabelSmallText} from '../core/Type';

// Temporary text field control that's actually functional.
// TODO: Remove this once the TextField component is functional.
export class TempTextField extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            textField: {
                height: CoreMetrics.ElementHeight.Small(),
                display: "block",
                backgroundColor: CoreMetrics.Color.LightUI.PrimaryBG,
                borderRadius: CoreMetrics.CornerRadius,
                outline: "none",
                paddingTop: 0,
                paddingLeft: CoreMetrics.ElementPadding.Medium(),
                paddingRight: CoreMetrics.ElementPadding.Medium(),
                border: 0,
                // Typography
                fontFamily: CoreMetrics.Type.Font.SansSerifRegular,
                fontWeight: 400,
                fontSize: CoreMetrics.Type.SansSerif.Medium.Size(),
                lineHeight: CoreMetrics.Type.LineHeight.Label,
            },
        });

        return (
            <input
                type="text"
                className={css(
                    styles.textField,
                    CoreStyles.hairlineOuterStroke
                )}
                onChange={this.handleChange}
                value={this.props.value}
            />
        );
    }
    handleChange = (event) => {
        const changeHandler = this.props.changeHandler;
        if (changeHandler != null) {
            changeHandler(event.target.value);
        }
    }
}

export default class TextField extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            textField: {
                height: CoreMetrics.ElementHeight.Small(),
                display: "flex",
                alignItems: "center",
                justifyItems: "stretch",
                backgroundColor: CoreMetrics.Color.LightUI.PrimaryBG,
                borderRadius: CoreMetrics.CornerRadius,
                outline: "none",
                paddingTop: 0,
                paddingLeft: CoreMetrics.ElementPadding.Medium(),
                paddingRight: CoreMetrics.ElementPadding.Medium(),
            },
        });

        let combinedStyles = [
            styles.textField,
            CoreStyles.hairlineOuterStroke,
            this.props.styles,
        ];
        const placeholder = this.props.placeholder;
        return (
            <div className={css(combinedStyles)}>
                <LabelSmallText styles={[CoreStyles.PlaceholderText]}>
                    {placeholder}
                </LabelSmallText>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/controls/TextField.jsx